import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="color-picker"
export default class extends Controller {
  static targets = ["picker", "select"];
  static values = {
    randomColors: Array,
  };

  pickerChanged() {
    if (this.hasSelectTarget) {
      this.selectTarget.value = "";
    }
  }

  selectChanged(event) {
    if (event.detail.value) {
      this.pickerTarget.value = event.detail.value; // Update picker to match selection
    }
  }

  randomize() {
    const randomColor =
      this.randomColorsValue[
        Math.floor(Math.random() * this.randomColorsValue.length)
      ];

    this.pickerTarget.value = randomColor;
  }
}
